import React, { useCallback } from "react";
import { useAuth0 } from "../../../react-auth0-spa";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import config from "../../../api_config.json";
import { useAppContext } from "../../../context";
import { updateCliente } from "../../../graphql/controllers/updateCliente";


export const DissociateClienteButton = (props) => {
  const { value, triggerRefresh } = props;
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const graphqlUrl = `${config.baseUrl[env]}/graphql`;

  const dissociateCliente = useCallback(
    async (cliente) => {
      console.log("Dissociate Cliente", cliente);
      try {
        const token = await getTokenSilently();
        const graphql = {
          url: graphqlUrl,
          token,
        }

        const variablesClienti = {
          id: cliente.objectId,
          fields: {
            terzista_org_pointer: null,
          },
        };

        const response = await updateCliente(graphql, variablesClienti)

        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [getTokenSilently, graphqlUrl]
  );

  return (
    <Popconfirm
      title="Dissocia il cliente"
      description="Sei sicuro di voler dissociare questo cliente?"
      onConfirm={async () => {
        await dissociateCliente(value);
        await triggerRefresh();
      }}
      okText="Si"
      cancelText="No"
    >
      <Button danger
        icon={<DeleteOutlined />}
        style={{ width: 60 }}
      ></Button>
    </Popconfirm>
  );
};

export default DissociateClienteButton;
